import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FilterSettingsModel, GridComponent, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { Subscription } from 'rxjs';
import { UsuarioService } from 'src/app/autenticacao/usuario.service';
import { HistoricoClinicoConsultaDto } from 'src/app/dtos/historias-clinicas/historia-clinica-dto';
import { PacienteDto } from 'src/app/dtos/pacientes/paciente-dto';
import { HistoriaClinicaCadastroComponent } from 'src/app/historia-clinica/historia-clinica-cadastro/historia-clinica-cadastro.component';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { RelatorioService } from 'src/app/relatorio/relatorio.service';
import { HistoriaClinicaService } from 'src/app/servicos/historia-clinica.service';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { HistoriaClinicaRelatorioService } from 'src/app/servicos/relatorios/historia-clinica-relatorio.service';

@Component({
  selector: 'app-paciente-historia-lista',
  templateUrl: './paciente-historia-lista.component.html',
  styleUrls: ['./paciente-historia-lista.component.less']
})
export class PacienteHistoriaListaComponent implements OnInit, OnDestroy {

  @ViewChild('modalHistoria')
  modalHistoria!: HistoriaClinicaCadastroComponent;

  @ViewChild('grid')
  grid!: GridComponent;

  toolbarItens: Object[] | null = null;
  
  registros: Object | null = null;

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }
  
  _paciente: PacienteDto | null = null;

  apenasConsulta: boolean = false;
  subs: Subscription | null = null;
  
  constructor(private historiaServico: HistoriaClinicaService, 
    private paciente: PacienteService,
    private historiaRelatorioSerivce: HistoriaClinicaRelatorioService,
    private relatorioService: RelatorioService,
    private toast: ToastService,
    private usuario: UsuarioService) { }

  ngOnDestroy(): void {
    this.subs?.unsubscribe();
  }

  ngOnInit(): void {
    this.toolbarItens = this.criarToolbar(); 

    this.subs = this.paciente.pacienteAtual$.subscribe((paciente) => {
      this._paciente = paciente;
      this.carregar();
    });
  }

  criarToolbar(): Object[] {
    return [
      { id: 'imprimir', text: 'Imprimir', prefixIcon: 'fal fa-print' },
      'Search'
    ];
  }

  toobarClick(event: ClickEventArgs) {
    if(event.item.id === 'imprimir') {
      this.imprimirHistoriaClinica();
    }
  }

  abrirConsulta() {
    let historia = this.grid.getSelectedRecords() as HistoricoClinicoConsultaDto[];

    if(historia.length === 0) {
      this.toast.showInfo('Selecione um registro.');
      return;
    }

    this.modalHistoria.abrirParaConsultaEdicao(historia[0].id).subscribe(() => this.carregar());
  }

  imprimirHistoriaClinica() {
    if(this._paciente === null)
      throw 'this._paciente is null';

    let requisicao = this.historiaRelatorioSerivce.requisicarHistoriaClinica(this._paciente.id);
    this.relatorioService.visualizarRelatorio(requisicao, 'História Clínica do Paciente');
  }

  carregar() {
    if(this._paciente === null)
      throw 'this._paciente is null';

    this.historiaServico
    .listarHistoricos(this._paciente.id)
    .subscribe((historias) => {
      this.registros = historias;
    });
  }

}
